import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnDestroy,
  Renderer2,
  ViewChildren,
  AfterViewChecked,
  QueryList,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ButtonComponent } from '../../../molecules/button/button.component';
import { ButtonType } from '../../../../shared/enums/button-type.enums';
import { LinkComponent } from '../../../atoms/link/link.component';
import { PodcastItems } from '../../../../shared/interfaces/podcast-item.interface';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ImageComponent } from '../../../atoms/image/image.component';
import ImageType from '../../../../shared/enums/image-type.enums';
import ViewportType from '../../../../shared/enums/viewport-type.enums';
import { Link } from '../../../../shared/interfaces/link.interface';
import LinkType from '../../../../shared/enums/link-type.enums';
import {
  CaasComponent,
  CaasPodcast,
} from '../../../../shared/interfaces/caas/caas.interface';
import { HrefType } from '../../../../shared/enums/href-type.enums';
import { PodcastService } from '../../../../services/podcast.service';
import { Subscription } from 'rxjs';
import { CaasRoutesService } from '../../../../services/caas-routes.service';
import { ImagesService } from '../../../../services/images.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CapitalizePipe } from '../../../capitalize.pipe';

@Component({
  selector: 'hdi-podcast',
  standalone: true,
  templateUrl: './podcast.component.html',
  styleUrls: ['./podcast.component.scss'],
  imports: [
    CommonModule,
    ButtonComponent,
    ImageComponent,
    LinkComponent,
    CapitalizePipe,
  ],
  animations: [
    trigger('rotateAnimation', [
      state('default', style({ transform: 'rotate(0deg)' })),
      state('clicked', style({ transform: 'rotate(90deg)' })),
      transition('default <=> clicked', animate('300ms ease-out')),
    ]),
  ],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class PodcastComponent
  implements AfterViewInit, AfterViewChecked, OnChanges, OnDestroy
{
  isOpen: boolean[] = [];
  accordion: ButtonType = ButtonType.OPEN_CLOSE_SECONDARY;
  @Input() id?: string = '';
  @Input() caasData?: CaasPodcast | CaasComponent;
  @Input() headerLabel: string = 'Podcast';
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() PodcastItems!: PodcastItems[];
  @Input() title: string | undefined = '';
  @Input() storybook: boolean = false;
  @Input() type: ImageType = ImageType.IMAGE_100;
  @Input() link?: Link;
  @Input() linkHeadline?: string;
  @Input() expandState?: string;
  @Input() isSectionBg: boolean = false;
  @ViewChild('podcast_content', { static: true }) AccordionToggle!: ElementRef;
  @ViewChild('iframeContainer', { static: false }) iframeContainer!: ElementRef;

  @ViewChildren('podcastsRef') podcastsRef!: QueryList<ElementRef>;
  isPodcastHub = false;
  moreLessType = ButtonType.SECONDARY_ICON;
  visiblePodcasts = 5;
  podcastStep = 3;
  isUnrolledLabel = 'Mehr Podcasts anzeigen';
  isUnrolledIcon = 'plus';
  LinkType = LinkType;
  HrefType = HrefType;
  animationStates: string[] = [];
  currentIframe?: string;
  safeIframe?: SafeHtml;
  currentIframes?: string[];
  safeIframes?: SafeHtml[];

  iframeSubscription?: Subscription;
  multipleIframeSubscription?: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private podcastService: PodcastService,
    private renderer: Renderer2,
    private caasRoutesService: CaasRoutesService,
    private imagesService: ImagesService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit() {
    if (this.PodcastItems && this.PodcastItems.length && !this.caasData) {
      this.isOpen = this.PodcastItems.map(() => false);
      this.animationStates = this.isOpen.map((isOpen) =>
        isOpen ? 'clicked' : 'default'
      );
    }

    // URL-Fragment verarbeiten
    this.handleFragment();
  }

  private handleFragment(): void {
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        this.openAccordionById(fragment);
      }
    });
  }

  private openAccordionById(id: string): void {
    const index = this.PodcastItems.findIndex(
      (podcast) =>
        podcast.id.toString().trim().toLowerCase() ===
        id.toString().trim().toLowerCase()
    );

    if (index !== -1) {
      this.isOpen.fill(false);
      this.isOpen[index] = true;
      this.animationStates.fill('default');
      this.animationStates[index] = 'clicked';
      this.fetchSingleIframe(index);
      this.unRollAcoordion(this.visiblePodcasts, this.podcastStep, index, id);
    }
  }

  ngAfterViewChecked(): void {
    if (this.isPodcastHub) {
      this.setVisiblePodcasts();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData']) {
      switch (
        (this.caasData as CaasPodcast).formData.st_layout.value.identifier
      ) {
        case 'section':
          this.setCaasLink();
          this.filterCaasPodcast();
          this.setCaasOpenState('section');
          break;
        case 'hub':
          this.PodcastItems = this.getPodcastBySerieId();
          this.isPodcastHub = this.PodcastItems.length > this.visiblePodcasts;
          this.setVisiblePodcasts();
          this.setCaasOpenState('hub');
          break;
      }

      console.log('Podcast Data:', this.caasData);
    }
  }

  setCaasOpenState(type: 'section' | 'hub') {
    this.isOpen = new Array(this.PodcastItems?.length ?? 0).fill(false);
    this.expandState = this.caasData?.formData?.st_expand?.value?.identifier;
    switch (this.expandState) {
      case 'firstOpen':
        this.isOpen[0] = true;
        this.animationStates = new Array(this.PodcastItems?.length ?? 0).fill(
          'default'
        );
        this.animationStates[0] = 'clicked';
        this.fetchSingleIframe(0);
        break;
      case 'allOpen':
        this.isOpen.fill(true);
        this.animationStates = new Array(this.PodcastItems?.length ?? 0).fill(
          'clicked'
        );
        if (type === 'hub') {
          this.fetchMultipleIframes('automatic');
        } else {
          switch (
            (this.caasData as CaasPodcast)?.formData?.st_selection_type?.value
              ?.identifier
          ) {
            case 'automatic':
              this.fetchMultipleIframes('automatic');
              break;
            case 'manual':
              this.fetchMultipleIframes('manual');
              break;
          }
        }
        break;
      case 'allClosed':
        this.isOpen.fill(false);
        this.animationStates = new Array(this.PodcastItems?.length ?? 0).fill(
          'default'
        );
        break;
      default:
        this.isOpen.fill(false);
        this.animationStates = new Array(this.PodcastItems?.length ?? 0).fill(
          'default'
        );
        break;
    }
  }

  unRollAcoordion(
    visiblePodcasts: number,
    podcastStep: number,
    index: number,
    podcastId: string
  ) {
    const topBarOffset = 104;
    const steps = Math.round((index - 1 - visiblePodcasts) / podcastStep);
    for (let i = 0; i <= steps; i++) {
      this.showMoreLess();
    }
    // Scrollen zum Accordion
    setTimeout(() => {
      const element = document.getElementById(podcastId);
      if (element) {
        const topOffset =
          element.getBoundingClientRect().top + window.scrollY - topBarOffset;
        window.scrollTo({ top: topOffset, behavior: 'smooth' });
      }
    }, 100);
  }

  setCaasLink() {
    this.linkHeadline =
      (this.caasData as CaasPodcast)?.formData?.st_header?.value ?? '';
    if ((this.caasData as CaasPodcast).formData.st_link.value) {
      this.link = {
        label:
          (this.caasData as CaasPodcast)?.formData?.st_link?.value?.formData
            ?.lt_link_label?.value ?? '',
        hrefType: HrefType.ANGULAR_ROUTE,
        href:
          this.caasRoutesService.getSeoRouteByIdentifier(
            this.caasData?.formData?.st_link?.value?.formData?.lt_link_internal
              ?.value?.identifier ?? '',
            this.router.config
          )?.path ?? '404',
        title:
          this.caasData?.formData?.st_link?.value?.formData?.lt_link_title
            ?.value ?? '',
      };
    }
  }

  filterCaasPodcast() {
    let podcastQuantity = 3;
    switch (
      (this.caasData as CaasPodcast)?.formData?.st_selection_type?.value
        ?.identifier
    ) {
      case 'automatic': {
        const podcastSeries = this.getPodcastBySerieId();
        switch (
          (this.caasData as CaasPodcast)?.formData?.st_quantity?.value
            ?.identifier
        ) {
          case '6':
            podcastQuantity = 6;
            this.PodcastItems = this.sortPodcastByDate(podcastSeries).slice(
              0,
              podcastQuantity
            );
            break;
          case '9':
            podcastQuantity = 9;
            this.PodcastItems = this.sortPodcastByDate(podcastSeries).slice(
              0,
              podcastQuantity
            );
            break;
          default:
            podcastQuantity = 3;
            this.PodcastItems = this.sortPodcastByDate(podcastSeries).slice(
              0,
              podcastQuantity
            );
        }
        break;
      }
      case 'manual': {
        const hasPodcasts = this.handleWarning('no podcast found');
        if (!hasPodcasts) return;
        this.PodcastItems = this.podcastService.getManualSelectionPodcasts(
          (this.caasData as CaasPodcast)?.formData?.st_items?.value
        );
        break;
      }
    }
  }

  getPodcastBySerieId(): PodcastItems[] {
    if (
      (this.caasData as CaasPodcast)?.formData?.st_podcast?.value?.identifier
    ) {
      return this.podcastService.getPodcastItemsBySerieId(
        (this.caasData as CaasPodcast).formData.st_podcast.value.identifier
      );
    }
    return [];
  }

  sortPodcastByDate(podcastItems: PodcastItems[]): PodcastItems[] {
    return podcastItems.sort((a, b) => b.timestamp - a.timestamp);
  }

  handleWarning(message: string): boolean {
    if (
      (this.caasData as CaasPodcast)?.formData?.st_items?.value.length === 0
    ) {
      console.warn(message);
      return false;
    }
    return true;
  }

  setVisiblePodcasts() {
    if (this.podcastsRef) {
      this.podcastsRef.forEach((podcast, index) => {
        if (index >= this.visiblePodcasts) {
          this.renderer.setStyle(podcast?.nativeElement, 'display', 'none');
        }
      });
    }
  }

  checkUnrolledState() {
    if (this.visiblePodcasts >= this.PodcastItems.length) {
      this.isUnrolledLabel = 'Weniger Podcasts anzeigen';
      this.isUnrolledIcon = 'minus';
    } else {
      this.isUnrolledLabel = 'Mehr Podcasts anzeigen';
      this.isUnrolledIcon = 'plus';
    }
  }

  showMoreLess() {
    if (this.visiblePodcasts < this.PodcastItems.length) {
      this.visiblePodcasts += this.podcastStep;
      if (this.podcastsRef) {
        this.podcastsRef.forEach((podcast, index) => {
          if (index < this.visiblePodcasts) {
            this.renderer.setStyle(podcast?.nativeElement, 'display', 'grid');
          }
        });
        this.checkUnrolledState();
      }
    } else {
      this.visiblePodcasts = 5;
      if (this.podcastsRef) {
        this.podcastsRef.forEach((podcast, index) => {
          if (index >= this.visiblePodcasts) {
            this.renderer.setStyle(podcast?.nativeElement, 'display', 'none');
          }
        });
      }
      this.checkUnrolledState();
    }
  }

  toggleOpenClose(index: number) {
    if (this.animationStates[index] === 'default') {
      this.animationStates.map((state, i) => {
        if (state === 'clicked') {
          this.animationStates[i] = 'default';
          this.isOpen[i] = false;
        }
      });
    }
    this.animationStates[index] = this.isOpen[index] ? 'default' : 'clicked';
    this.isOpen[index] = !this.isOpen[index];
  }

  fetchSingleIframe(index: number) {
    this.safeIframes = undefined;
    this.currentIframes = undefined;
    if (this.PodcastItems?.length > 0) {
      this.iframeSubscription = this.podcastService
        .getSinglePodcastIframe(this.PodcastItems[index].url)
        .subscribe((iframe: SafeHtml | null) => {
          if (iframe) {
            this.safeIframe = iframe;
            this.cdr.detectChanges();
          }
        });
    }
  }

  fetchMultipleIframes(selectionType: 'automatic' | 'manual') {
    this.safeIframe = undefined;
    this.currentIframe = undefined;

    this.multipleIframeSubscription = this.podcastService
      .getMultiplePodcastIframes(this.PodcastItems)
      .subscribe({
        next: (podcastItems: PodcastItems[]) => {
          if (selectionType === 'automatic') {
            this.PodcastItems = this.sortPodcastByDate(podcastItems);
          } else {
            this.PodcastItems = podcastItems;
          }
        },
        error: (error) => {
          console.error('Error fetching iframes:', error);
        },
      });
  }

  handleClick(index: number) {
    this.toggleOpenClose(index);
    if (this.animationStates[index] === 'clicked') {
      this.fetchSingleIframe(index);
    }
  }

  getAltTextById(id: string): string | undefined {
    return this.imagesService.getAltTextById(id);
  }

  ngOnDestroy(): void {
    this.iframeSubscription?.unsubscribe();
    this.multipleIframeSubscription?.unsubscribe();
  }
}
